import type { IAPIRes } from '@/types/IAPIRes';
import { useAxios } from '@/boot/axios';
import { IMetaTags } from '@/types/IMetaTags';

export const getReportMetaContent = async (
  url: string,
): Promise<IAPIRes<IMetaTags>> => {
  const { axiosInstance } = useAxios();
  const response = await axiosInstance.get<IAPIRes<IMetaTags>>(
    `/page/content?url=${url}`,
  );
  return response.data;
};
